import { formatTime } from '@/filters';

export function formatShipmentDateTime(
  value: string | null | undefined,
): string {
  if (!value) return '—';
  const formatted = formatTime(value, 'MMM d, yyyy h:mm aa');
  return formatted ?? '—';
}

export function formatRelativeTimestamp(
  unixSeconds: number | null | undefined,
): string {
  if (unixSeconds == null || !Number.isFinite(unixSeconds)) return '—';
  const diff = Date.now() - unixSeconds * 1000;
  const mins = Math.floor(diff / 60_000);
  if (mins < 1) return 'Just now';
  if (mins === 1) return '1 min ago';
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours === 1) return '1 hour ago';
  if (hours < 24) return `${hours} hours ago`;
  const days = Math.floor(hours / 24);
  return days === 1 ? '1 day ago' : `${days} days ago`;
}

export function isStaleReport(
  unixSeconds: number | null | undefined,
  staleMs = 30 * 60_000,
): boolean {
  if (unixSeconds == null || !Number.isFinite(unixSeconds)) return false;
  return Date.now() - unixSeconds * 1000 > staleMs;
}
